import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Info from "../shared/Info";
import {
  askToAgents,
  selectWorkflow,
} from "../../../state/ducks/workflow/index";
import KvkkModal from "../shared/KvkkModal";
import EminevimLoading from "../shared/EminevimLoading";

export class AskToAgent extends Component {
  state = {
    konu: "",
    aciklama: "",
    kvkkAccepted: false,
    kvkkMetni: "",
    isKvkkModalOpen: false,
    shouldAnimateCard: false,
    isProcessing: false,
    formErrors: {
      subject: "",
      description: "",
      kvkk: "",
    },
  };

  componentDidMount() {
    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  clearFieldError = (field) => {
    this.setState((prevState) => ({
      formErrors: {
        ...prevState.formErrors,
        [field]: "",
      },
    }));
  };

  validateForm = () => {
    const { konu, aciklama, kvkkAccepted } = this.state;
    const formErrors = {
      subject: "",
      description: "",
      kvkk: "",
    };

    if (!konu.trim()) {
      formErrors.subject = "Konu alanı boş bırakılamaz";
    }

    if (!aciklama.trim()) {
      formErrors.description = "Mesaj alanı boş bırakılamaz";
    }

    if (!kvkkAccepted) {
      formErrors.kvkk = "Devam etmek için onaylamalısınız";
    }

    return formErrors;
  };

  onSubmit = (e) => {
    e.preventDefault();

    const formErrors = this.validateForm();
    const hasErrors = Object.values(formErrors).some(Boolean);

    if (hasErrors) {
      this.setState({ formErrors });
      return;
    }

    this.setState({ isProcessing: true, formErrors: { subject: "", description: "", kvkk: "" } });
    Promise.resolve(this.props.askToAgents(this.state.konu, this.state.aciklama)).finally(() => {
      this.setState({ isProcessing: false });
    });
  };

  getKvkk = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ isKvkkModalOpen: true });
  };

  handleKvkkLoaded = (kvkkMetni) => {
    this.setState({ kvkkMetni });
  };

  closeKvkkModal = () => {
    this.setState({ isKvkkModalOpen: false });
  };

  renderFormField = (label, icon, control, errorMessage, htmlFor, hasError) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div
        className={`t-resetPassword-inputWrap t-submitDemand-inputWrap${
          hasError ? " t-error" : ""
        }`}
      >
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      {errorMessage ? (
        <p className="t-icinputHatamesajArea t-resetPassword-error">{errorMessage}</p>
      ) : (
        <div className="t-icinputHatamesajArea t-resetPassword-error" aria-hidden="true" />
      )}
    </div>
  );

  renderTextareaField = (label, icon, control, errorMessage, htmlFor, hasError) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div
        className={`t-resetPassword-inputWrap t-submitDemand-inputWrap t-submitDemand-inputWrap--textarea${
          hasError ? " t-error" : ""
        }`}
      >
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      {errorMessage ? (
        <p className="t-icinputHatamesajArea t-resetPassword-error">{errorMessage}</p>
      ) : (
        <div className="t-icinputHatamesajArea t-resetPassword-error" aria-hidden="true" />
      )}
    </div>
  );

  render() {
    const { workflow } = this.props;
    const { shouldAnimateCard, isProcessing, formErrors, kvkkAccepted } = this.state;

    if (workflow?.addedAgent) {
      return (
        <Info
          header="Talebiniz alınmıştır."
          body="Talebiniz ile ilgili gelişmeleri 'Talep Takibi' menüsünden takip edebilirsiniz."
          themeClass="t-memberDetail-header--blue"
          iconClass="t-icon-user-tie"
          pageTitle="Temsilcime Soru Sor"
          pageSubtitle="Mesajınız temsilcinize başarıyla iletildi."
          redirectTo="/Home/MyDemands"
          actionLabel="Talep Takibine Git"
        />
      );
    }

    return (
      <div className="t-askToAgent-page" style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Temsilcime Soru Sor</h1>
              <p className="t-memberInfo-pageSubtitle">
                Müşteri temsilcinize konu ve mesajınızı iletin; yanıtınızı talep takibinden takip edebilirsiniz.
              </p>
            </div>

            <article
              className={`t-memberInfo-card t-memberDetail-header--blue${
                shouldAnimateCard ? " t-memberInfo-card--enter" : ""
              }`}
            >
              <div className="t-memberInfo-cardHeader">
                <Link
                  to="/Home/AgentInfo"
                  className="t-memberDetail-headerBack"
                  title="Temsilci Bilgilerine Dön"
                  aria-label="Temsilci Bilgilerine Dön"
                >
                  <i className="t-icon-arrow-left2" aria-hidden="true" />
                </Link>

                <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                  <i className="t-icon-user-tie" aria-hidden="true" />
                </div>

                <div className="t-memberInfo-cardHeaderContent">
                  <h2 className="t-memberInfo-cardTitle">Temsilcime Mesaj Gönder</h2>
                  <div className="t-memberInfo-cardBadges">
                    <span className="t-memberDetail-headerBadge">Müşteri Temsilcisi</span>
                  </div>
                </div>
              </div>

              <form
                className="t-resetPassword-form t-submitDemand-form"
                onSubmit={this.onSubmit}
                noValidate
              >
                {this.renderFormField(
                  "Konu",
                  "t-icon-pen1",
                  (
                    <input
                      type="text"
                      placeholder="Konu başlığınızı yazınız"
                      id="subject"
                      name="subject"
                      value={this.state.konu}
                      required
                      maxLength="200"
                      onChange={(e) => {
                        this.setState({ konu: e.target.value });
                        this.clearFieldError("subject");
                      }}
                    />
                  ),
                  formErrors.subject,
                  "subject",
                  Boolean(formErrors.subject)
                )}

                {this.renderTextareaField(
                  "Açıklama",
                  "t-icon-bubble1",
                  (
                    <textarea
                      placeholder="Mesajınızı yazınız"
                      id="description"
                      name="description"
                      rows="3"
                      maxLength="1000"
                      required
                      value={this.state.aciklama}
                      onChange={(e) => {
                        this.setState({ aciklama: e.target.value });
                        this.clearFieldError("description");
                      }}
                    />
                  ),
                  formErrors.description,
                  "description",
                  Boolean(formErrors.description)
                )}

                <div
                  className={`t-submitDemand-kvkk${
                    formErrors.kvkk ? " t-submitDemand-kvkk--error" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    className="t-kvkkcheckbox"
                    id="onaychecked"
                    checked={kvkkAccepted}
                    onChange={(e) => {
                      this.setState({ kvkkAccepted: e.target.checked });
                      this.clearFieldError("kvkk");
                    }}
                  />
                  <span className="t-submitDemand-kvkkText">
                    <a id="kvkk-onayla" href="#kvkk-onayla" onClick={this.getKvkk}>
                      KVKK Taahhütnamesi
                    </a>
                    &apos;ni <strong>ONAYLIYORUM</strong>
                  </span>
                </div>
                {formErrors.kvkk ? (
                  <p className="t-resetPassword-error t-submitDemand-kvkkError">{formErrors.kvkk}</p>
                ) : null}

                <div className="t-resetPassword-actions">
                  <button
                    type="submit"
                    className="t-memberInfo-btn t-memberInfo-btn--primary"
                    disabled={isProcessing}
                  >
                    <span>Mesajımı Gönder</span>
                    <i className="t-icon-arrow-right2" aria-hidden="true" />
                  </button>
                </div>
              </form>
            </article>
          </div>
        </div>

        <div className="row" style={{ height: 30 }} />

        <KvkkModal
          isOpen={this.state.isKvkkModalOpen}
          onClose={this.closeKvkkModal}
          onLoaded={this.handleKvkkLoaded}
        />

        {isProcessing && (
          <div className="t-eminevimLoadingOverlay">
            <EminevimLoading subtext="Mesajınız gönderiliyor, lütfen bekleyiniz." compact />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workflow: selectWorkflow(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  askToAgents: (konu, aciklama) => dispatch(askToAgents(konu, aciklama)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AskToAgent);
